module.exports = __webpack_public_path__ + "static/assets/511715c9850b0b21c917312fe60900c8.svg";